// extracted by mini-css-extract-plugin
export default {"aroundCheckboxes":"style-module--aroundCheckboxes--0w1kR"};